import React, {useState } from "react";
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { Table,} from "react-bootstrap";
import { Link,useHistory} from "react-router-dom";
function PartnerCommission(props) {
  const history=useHistory()
  const [commission, setCommission] = useState("");
  const [vehicle, setpushvehicle] = useState([]);
  const [vehicleName, setVehicleName] = useState("");
  const { id } = props.match.params;
  var nameObject = [
    "Auto",
    "Bike",
    "3 Wheeler",
    "Tata Ace",
    "PickUp 8ft",
    "Tata 407",
    "SUV/MUV",
    "Sedan",
    "Hatch Back",
  ];
  const submitHandler = (e) => {
    e.preventDefault();
    if (!vehicle) {
      swal("Oops", "Vehicle  not added", "error", {
        button: "Try Again!",
        timer: 1000,
      });
    } else {
      const artical = {
        CommissionModel: vehicle,
      };
      axios
        .put(`${Baseurl.baseurl2}/onboarding/add-onboarding-commission/${id}`, artical)
        .then(
          (response) =>
            response.data.status
              ? swal("Commission Added", response.data.message, "success", {
                  button: "Done",
                  timer: 1000,
                })
              : swal("Oops", response.data.message, "error", {
                  button: "Try Again!",
                  timer: 1000,
                }),
          setpushvehicle([])
        )
        .catch((err) => {
          if(err.toString()==="Error: Network Error")
          {
            history.push('/offline')
          }
          else
          {
            history.push('/400')
          }
      })
    }
  };
 
  const Add = () => {
    let commissions=parseInt(commission)
    const vehicle1 = {
      VehicleType: vehicleName,
      VehicleCommision: commissions,
    };
    setpushvehicle(
      (oldArray) => oldArray.concat(vehicle1),
      () => {}
    );
    swal("Added", "Added successfully", "success", {
      showCancelButton: true,
      timer: 1000,
    });
    setCommission("");
  };
  return (
    <div className="col-16">
      <div
        className="card"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <h4 className="card-title text-white">Add Commission
         
          </h4>
          <Link to='/partner'>
          <button className="btn btn-primary float-right">Back</button>
          </Link>
        </div>
        <div className="card-body">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group row">
                
                  <div className="col-sm-4 mb-5" id="multiselect">
                    <label>Vehicle Name</label>
                    <select
                  className="form-control"
                  id="val-skill"
                  name="val-skill"
                  defaultValue={vehicleName}
                  onChange={(event) => {
                    setVehicleName(event.target.value);
                  }}
                >
                  <option selected="true" disabled="disabled"></option>
                  {nameObject &&
                    nameObject.map((val) => (
                      <option value={val}>{val}</option>
                    ))}
                </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12"></div>
          <strong>Additions</strong>
          <div className="form-row align-items-left mt-3">
            <div className="col-auto">
              <label>Vehicle Transaction Fee</label>
              <div className="input-group mb-2">
                <input
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={commission}
                  onChange={(e) => setCommission(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
                <button className="btn btn-primary ml-4" onClick={Add}>
                  Add
                </button>
              </div>
            </div>
          </div>

          <small class="text-white mt-3">
            You can add multiple vehicle at a time by clicking Add button
          </small>

          <br />
          <br />
          <Table responsive id="myTable" className="text-white">
            <thead>
              <tr>
                <th>
                  <strong className="text-white">Vehicle Name</strong>
                </th>

                <th>
                  <strong className="text-white">Commission</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* <tr> */}
              {vehicle.map((p, i) => (
                <tr>
                  <td>{p.VehicleType}</td>
                  <td>{p.VehicleCommision}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <button
            onClick={(e) => {
              submitHandler(e);
            }}
            className="btn btn-primary float-right"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default PartnerCommission;
